type TabPanelProps = {
  children: React.ReactNode;
  index: number;
  value: number;
};

function TabPanel({ children, index, value }: TabPanelProps) {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <>{children}</>}
    </div>
  );
}

export default TabPanel;
